import { mutationOptions } from '../../common/utils';
import { authAPIClient } from '../authAPIClient';
import { AUTH_QUERY_KEYS } from './keys';
import type {
  GenerateOtpRequest,
  GenerateOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
} from './types';

export const AUTH_QUERIES = {
  generateOtp: () =>
    mutationOptions<GenerateOtpResponse, unknown, GenerateOtpRequest>({
      mutationKey: AUTH_QUERY_KEYS.generateOtp(),
      mutationFn: (payload) => authAPIClient.generateOtp(payload),
    }),
  verifyOtp: () =>
    mutationOptions<VerifyOtpResponse, unknown, VerifyOtpRequest>({
      mutationKey: AUTH_QUERY_KEYS.verifyOtp(),
      mutationFn: (payload) => authAPIClient.verifyOtp(payload),
    }),
  verifyEmail: () =>
    mutationOptions<VerifyEmailResponse, unknown, VerifyEmailRequest>({
      mutationKey: AUTH_QUERY_KEYS.verifyEmail(),
      mutationFn: (payload) => authAPIClient.verifyEmail(payload),
    }),
  register: () =>
    mutationOptions<RegisterResponse, unknown, RegisterRequest>({
      mutationKey: AUTH_QUERY_KEYS.register(),
      mutationFn: (payload) => authAPIClient.register(payload),
    }),
  login: () =>
    mutationOptions<LoginResponse, unknown, LoginRequest>({
      mutationKey: AUTH_QUERY_KEYS.login(),
      mutationFn: (payload) => authAPIClient.login(payload),
    }),
  logout: () =>
    mutationOptions<LogoutResponse, unknown, void>({
      mutationKey: AUTH_QUERY_KEYS.logout(),
      mutationFn: () => authAPIClient.logout(),
    }),
};
